import Navbar from "./Navbar";
function Home() {
  return (
    <div className="frontPage">
      <div className="frontText">
        <h2>Welcome to Youples reviews</h2>
        <h2>your home to </h2>
        <h2>tell the tabletop what you think of your favourite games!</h2>
        <br></br>
        <br></br>
        <h2>To get started and see what others think please chose</h2>
        <h2>reviews for all reviews</h2>
        <h2>OR</h2>
        <h2>chose a category</h2>
      </div>
      <Navbar />
    </div>
  );
}

export default Home;
